module.exports = __webpack_public_path__ + "img/blog-1-x1.c23fdf62.jpg";